
<template>
   <div class="homeContainer"> 
      <div class="sectionInfo">
       <div class="sectionContent">
         <div class="pageTitle">
              Men of Courage International
         </div>
         <b-list-group horizontal="md">
         <b-list-group-item><div class='imgContainer'><img :src="logoMen" class="imgOpaque"/></div></b-list-group-item>
         <b-list-group-item>    
           <div class="recentEvent">
             <div class='heading'>Past Event</div> MOCI collaborates with Navy Sprint Football Team and Adolescent and Family Services to make 800 mental health bags for the children of Anne Arundel County!   
           </div>        
           <div class="introText">
               <div>First Men of Courage Discussion </div>
                <div style="font-style: italic; margin-top:10px;">Starbucks</div>
                <div style="font-style: italic;">2122 Generals Hwy, Annapolis, MD  21401</div>
                <div style="font-weight:600; margin-top:10px">Wednesday, January 29th, 2025 6am </div>
               <div style="margin-top:20px">We will be meeting twice a month!</div>
               <div style="margin-top:20px">Please contact us via <a href="mailto:drf@menofcourageinternational.org">email</a> (drf@menofcourageinternational.org) or just show up!</div>
          </div>
         </b-list-group-item>
         </b-list-group>
       </div>
       </div>
   </div>
</template>
<script>
export default {
    data: function () {
     return { 
       logoMen : require('@/assets/logoMen.jpg')
     }
    }
}
</script>
<style>
  .homeContainer{
    background-color: #a52411;
      -moz-background-size: cover;
      -webkit-background-size: cover;
      -o-background-size: cover;
       background-size: cover;
      height: 100%;
      width: 100%;
      position: fixed;
      bottom: 0;
      z-index: 2;
  }
  .sectionContent{
    text-align: center;
    margin-top: 100px;
  }
  .sectionInfo{
    padding: 0px;
  }
  .pageTitle{
    text-align: center;
    background-color: #a52411;
    color: #fff;
    font-weight: bold;
    padding: 10px;
    font-size: 28px;
   }
  .introText{
      letter-spacing:1.5px;
      font-family: Open Sans;
      font-size: 1.4em;
      margin-top: 5%;
  }  
  .recentEvent{
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f0f0f0;
    padding: 3px;
  }
  .recentEvent > .heading {
    color: #ff0000;
    font-weight: 600;
    display: inline-block;
  }
  .imgOpaque {
     opacity: 0.9;  
     height: 400px; 
  }
/* Image responsiveness */
@media (orientation: landscape){
    .imgContainer{
      margin: 6px;
      background-color: #f0f0f0;
      border-radius: 2px;
      border: 1px solid;
      -webkit-box-shadow: 5px 10px 18px navy ;
      box-shadow: 2px 2px 10px navy;
    }
}
/* iPhone 6 in portrait */
@media only screen 
and (min-device-width : 1px) 
and (max-device-width : 374px) 
and (orientation : portrait) {
    .pageTitle{font-size: 0.9em;}
    .introText{
      margin-top: 8%;
      font-size:1.0em;
    }
    .imgOpaque{height: 130px;}
}
/* iPhone 6 in portrait */
@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 667px) 
and (orientation : portrait) {
    .pageTitle{font-size: 1.2em;}
    .introText{
      margin-top: 8%;
      font-size:1.0em;
    }
    .imgOpaque{height: 230px;}
}
/* iPhone 6 in landscape */
@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 667px) 
and (orientation : landscape) { 
   .list-group-horizontal-md {
    flex-direction: row;
  }
    .pageTitle{font-size: 1.1em;}
    .introText{
      margin-top: 1%;
      font-size:0.9em;
      letter-spacing: 1.0px;
    }
    .imgOpaque{height: 150px !important;}
}
/* iPad smaller in landscape */
@media only screen 
and (min-device-width : 668px) 
and (max-device-width : 767px) 
and (orientation : landscape) {  
  .list-group-horizontal-md {
    flex-direction: row;
  }
    .pageTitle{font-size: 1.3em;}
    .introText{
      margin-top: 10%;
      font-size:1.0em;
    }
    .imgOpaque{height: 200px !important;}
}
/* Galaxy S8 and above */
@media only screen
and (min-device-width: 360px)
and (max-device-width: 770px)
and (-webkit-min-device-pixel-ratio: 4)
and (orientation: landscape) {
  /* CSS Rules Here */
  .list-group-horizontal-md {
    flex-direction: row;
  }
    .pageTitle{font-size: 1.2em;}
    .introText{
      margin-top: 3%;
      font-size:1.0em;
    }
    .imgOpaque{height: 161px !important;}
}
/* Galaxy S8 and above */
@media only screen
and (min-device-width: 360px)
and (max-device-width: 740px)
and (-webkit-min-device-pixel-ratio: 4)
and (orientation: portrait) {
  /* CSS Rules Here */
  .list-group-horizontal-md {
    flex-direction: column;
  }
    .pageTitle{font-size: 1.6em;}
    .introText{
      margin-top: 20%;
      font-size:1.2em;
    }
    .imgOpaque{height: 230px !important;}
}
/* iPad in portrait */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait) {
  .list-group-horizontal-md {
    flex-direction: column;
  }
    .pageTitle{font-size: 1.3em;}
    .introText{
      margin-top: 3%;
      font-size:1.2em;
    }
    .imgOpaque{height: 300px !important;}
}
/* iPad in landscape */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : landscape) {  
  .list-group-horizontal-md {
    flex-direction: row;
  }
    .pageTitle{font-size: 1.5em;}
    .introText{
      margin-top: 6%;
      font-size:1.1em;
    }
    .imgOpaque{height: 220px !important;}
}

/* iPad in portrait */
@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px) 
and (orientation : portrait) {
  .list-group-horizontal-md {
    flex-direction: column;
  }
    .pageTitle{font-size: 1.6em;}
    .introText{
      margin-top: 6%;
      font-size:1.5em;
    }
    .imgOpaque{height: 380px !important;}
}

</style>
